import React, { createContext, useCallback, useMemo, useState } from "react";

const AUTH_STORAGE_KEY = "tastevani-account-session";

export const AuthContext = createContext({
  isAuthenticated: false,
  login: () => false,
  logout: () => {},
});

function getStoredSession() {
  try {
    return window.localStorage.getItem(AUTH_STORAGE_KEY) === "authenticated";
  } catch {
    return false;
  }
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(getStoredSession);

  const login = useCallback((username, password) => {
    const isValid = username === "admin" && password === "admin123";
    if (!isValid) return false;

    try {
      window.localStorage.setItem(AUTH_STORAGE_KEY, "authenticated");
    } catch {
      // The in-memory session still works when storage is unavailable.
    }
    setIsAuthenticated(true);
    return true;
  }, []);

  const logout = useCallback(() => {
    try {
      window.localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch {
      // Keep logout functional when storage is unavailable.
    }
    setIsAuthenticated(false);
  }, []);

  const value = useMemo(
    () => ({ isAuthenticated, login, logout }),
    [isAuthenticated, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
